import { NumericFormat } from 'react-number-format';
import TextField from "@mui/material/TextField";
import React from "react";

export default function CurrencyInput(props){

    return <NumericFormat
        customInput={TextField}
        thousandSeparator="."
        decimalSeparator=","
        prefix="R$ "
        decimalScale={2}
        allowNegative={false}
        isAllowed={({ floatValue }) => {
            // Permite no máximo 10 dígitos antes da vírgula
            return floatValue === undefined || floatValue < 10000000000;
        }}
        {...props}
    />
}